import { FC } from "react";
import {
    CoverImage,
    CoverImageWrapper,
    ProfileImage,
    ProfileImageContainer,
} from "../HighLight.styled";
import { useImageSection } from "./useImageSection";

export const ImageSection: FC = () => {
    const { images, handleError } = useImageSection();

    return (
        <>
            <CoverImageWrapper>
                <CoverImage
                    src={images.cover?.url || ""}
                    onError={handleError}
                />
                <ProfileImageContainer>
                    <ProfileImage
                        src={images.profile?.url || ""}
                        onError={handleError}
                    />
                    {/* <CountryIconContainer>
                        <CountryIcon />
                    </CountryIconContainer> */}
                </ProfileImageContainer>
            </CoverImageWrapper>
        </>
    );
};
